import { LIST, linkNode } from "./common";
import { ELEMENT_TRANSFORMERS } from "./markdown-element-transformers";

import type { TextFormatTransformer, Transformer } from "@lexical/markdown";

const TEAMS_BOLD_STAR: TextFormatTransformer = {
  format: ["bold"],
  intraword: false,
  tag: "**",
  type: "text-format",
};

const TEAMS_ITALIC_UNDERSCORE: TextFormatTransformer = {
  format: ["italic"],
  intraword: false,
  tag: "_",
  type: "text-format",
};

export const TeamsMrkDwnTransformers: Transformer[] = [
  TEAMS_ITALIC_UNDERSCORE,
  TEAMS_BOLD_STAR,
  LIST("* "),
  linkNode((text, url) => `[${text}](${url})`),
  ...ELEMENT_TRANSFORMERS("teams"),
];
